// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__MqGFa","form":"style_form__ntRHn","success":"style_success__uwYLd","success_link":"style_success_link__+8AfP","error":"style_error__fjYtj"};